module.exports = __webpack_public_path__ + "static/media/display-suite-02.335792fe.png";